module.exports = __webpack_public_path__ + "static/img/1216mask2.bc58ce2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1216mask2.png
// module id = zUxd
// module chunks = 1